<template>
  <fragment>
    <CardModule :title="$t('events.event-config.images')">
      <v-row>
        <v-card-subtitle>
          <i18n path="events.event-config.images-message-1" tag="span">
            <template v-slot:text>
              <strong>{{
                $t("events.event-config.two-required-images")
              }}</strong>
            </template>
            <template v-slot:banner>
              <strong>banner</strong>
            </template>
          </i18n>
          <br />
          <i18n path="events.event-config.images-message-2" tag="span">
            <template v-slot:text>
              <strong>{{
                $t("events.event-config.optional-third-image")
              }}</strong>
            </template>
          </i18n>
        </v-card-subtitle>
        <v-card-subtitle v-if="!imageLimit">
          <v-chip-group
            mandatory
            active-class="primary--text"
            v-model="typeImage"
          >
            <v-chip
              small
              :disabled="hasEmphasisImage"
              filter
              outlined
              value="destaque"
              color="tertiary"
            >
              Banner*
            </v-chip>
            <v-chip
              small
              filter
              outlined
              :disabled="hasCardImage"
              value="imagem1"
              color="tertiary"
            >
              {{ $t("events.event-config.catalog") }}*
            </v-chip>
            <v-chip
              small
              filter
              outlined
              :disabled="hasMapImage"
              value="map"
              color="tertiary"
            >
              {{ $t("events.event-config.map") }}
            </v-chip>
          </v-chip-group>
        </v-card-subtitle>
        <v-card-text>
          <div
            class="image-uploader rounded-lg"
            @dragover.prevent
            @drop="handleDrop"
            @dragleave="enterHover = false"
            @dragover="enterHover = true"
            :class="{ 'drag-hover': enterHover }"
            @click="openFileInput"
            v-if="!imageLimit"
          >
            <div v-if="uploadLoading">
              <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
                color="primary"
              >
              </v-progress-circular>
            </div>
            <div v-else>
              <input
                type="file"
                ref="fileInput"
                accept="image/*"
                style="display: none"
                @change="handleFileInput"
              />
              <v-icon class="upload-icon"> mdi-cloud-upload </v-icon>
              <div class="upload-text">
                <p>{{ $t("events.event-config.drag-and-drop-image") }}</p>
                <p>{{ $t("events.event-config.click-to-upload") }}</p>
              </div>
            </div>
            <span class="image-quantity"> {{ images.length }}/3 </span>
          </div>
          <v-progress-linear
            v-if="uploading"
            :value="getProgress"
            height="15"
            :buffer-value="getProgress + 10"
            rounded
            color="tertiary"
            >{{ getProgress }}%</v-progress-linear
          >
          <ul v-if="!imageLimit" class="grey--text body-2 mt-2">
            <li>
              {{ $t("events.event-config.banner-image") }}:
              <span class="font-weight-bold"> 1920x672px</span>
            </li>
            <li>
              {{ $t("events.event-config.catalog-image") }}:
              <span class="font-weight-bold"> 1080x1920px</span>
            </li>
            <li>
              {{ $t("events.event-config.map-image") }}
              <span class="font-weight-bold"> 1024x768px</span>
            </li>
            <li>{{ $t("events.event-config.image-format-and-size") }}</li>
          </ul>
          <p class="grey--text body-2">
            {{ $t("events.event-config.image-size-info") }}
          </p>
          <v-col>
            <v-row>
              <div
                class="image-preview mt-5 rounded-lg mr-10"
                v-for="(image, index) in images"
                :key="index"
              >
                <v-img
                  :src="image.url"
                  max-height="100"
                  cover
                  class="rounded-t-lg rounded-b-lg"
                />
                <v-card-text class="text-center">
                  {{ cardText(image.type) }}
                </v-card-text>
                <v-btn
                  color="error red lighten-2"
                  fab
                  x-small
                  class="remove-img-btn rounded-pill"
                  @click="remover(image.id, index)"
                >
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </div>
            </v-row>
          </v-col>
        </v-card-text>
      </v-row>
    </CardModule>
    <ModalVisualizarImagem :image="imagemModal" screen="produto" />
    <confirm-modal
      v-model="deleteImage"
      @confirm="removeImage"
      @cancel="deleteImage = false"
      :title="$t('events.event-config.confirmation')"
      :subtitle="$t('events.event-config.confirmation-subtitle')"
    />
  </fragment>
</template>

<script>
import mixins from "@/mixins";
import CardModule from "@/components/cards/CardModule.vue";
import ModalVisualizarImagem from "@/components/global/modal-visualizar-imagem.vue";
import confirmModal from "@/components/global/newConfirmDialog.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
const { products, formRules } = mixins;

export default {
  name: "Customization",
  components: {
    ModalVisualizarImagem,
    confirmModal,
    CardModule,
  },
  mixins: [products, formRules],
  data() {
    return {
      deleteImage: false,
      imagePreview: [],
      typeImage: "destaque",
      enterHover: false,
      imagemModal: "",
      commonImageTypes: [
        {
          key: "Imagem Home",
          value: "imagem1",
          show: true,
        },
        {
          key: "Imagem Produto",
          value: "destaque",
          show: true,
        },
        {
          key: "Mapa",
          value: "map",
          show: true,
        },
      ],
    };
  },
  methods: {
    ...mapActions([
      "uploadEventImage",
      "getImage2",
      "showSnackbarSuccess",
      "cleanImagesFromRegister",
    ]),
    ...mapMutations(["setImages"]),
    cardText(type) {
      return type === "imagem1"
        ? this.$t("events.event-config.image-for-ecommerce")
        : type === "destaque"
        ? this.$t("events.event-config.image-for-banner")
        : this.$t("events.event-config.sector-map");
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    remover(id, index) {
      this.deleteImage = true;
      this.idToDelete = id;
      this.indexToDelete = index;
    },
    removeImage() {
      if (
        this.indexToDelete !== null &&
        this.indexToDelete >= 0 &&
        this.indexToDelete < this.images.length
      ) {
        this.images.splice(this.indexToDelete, 1);
        this.showSnackbarSuccess(this.$t("events.event-config.image-removed"));
      } else if (this.idToDelete !== null) {
        this.setImages(
          this.images.filter(image => image.id !== this.idToDelete)
        );
        this.showSnackbarSuccess(this.$t("events.event-config.image-removed"));
      } else {
        console.error(this.$t("events.event-config.no-valid-index"));
      }
      this.deleteImage = false;
    },
    handleChipChange(image, index) {
      const img = this.imagePreview[index];

      this.imagePreview.forEach(el => {
        if (el !== img) {
          image.type === "imagem1"
            ? (el.type = "destaque")
            : image.type === "destaque"
            ? (el.type = "map")
            : image.type === "destaque" && image.type === "imagem1"
            ? (el.type = "map")
            : (el.type = "imagem1");
        }
      });
    },
    handleFileInput(event) {
      const file = event.target.files[0];
      this.uploadImage(file);
    },
    handleDrop(event) {
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      this.uploadImage(file);
    },
    async uploadImage(file) {
      this.enterHover = false;

      if (file) {
        try {
          const base64Image = await this.fileToBase64(file);
          await this.uploadEventImage({
            file: base64Image,
            store: this.getStoreId,
            product: this.getProductId,
            image: this.typeImage,
          });

          if (this.typeImage == "imagem1") {
            await this.getImage2({
              file: base64Image,
              store: this.getStoreId,
              product: this.getProductId,
              image: "imagem2",
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = event => {
          resolve(event.target.result);
        };

        reader.onerror = error => {
          reject(error);
        };

        reader.readAsDataURL(file);
      });
    },
  },
  destroyed() {
    this.cleanImagesFromRegister();
  },
  computed: {
    ...mapGetters(["images", "uploadLoading"]),
    imageLimit() {
      return this.images.length === 3;
    },
    hasEmphasisImage() {
      return this.images.some(image => image.type === "destaque");
    },
    hasCardImage() {
      return this.images.some(image => image.type === "imagem1");
    },
    hasMapImage() {
      return this.images.some(image => image.type === "map");
    },
    uploading() {
      return this.getProgress > 0 && this.getProgress < 100;
    },
    filteredData() {
      if (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "IFRAME"
      ) {
        return this.tipo_imagem_iframe.filter(item => item.show === true);
      }
      if (this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "LINK") {
        return this.tipo_imagem_link.filter(item => item.show === true);
      }
      return this.tipo_imagem.filter(item => item.show === true);
    },
    noHasData() {
      return (
        this.$produtos_gerenciar.cadastro.customizacao &&
        this.$produtos_gerenciar.cadastro.customizacao.imagens_array &&
        this.$produtos_gerenciar.cadastro.customizacao.imagens_array.length == 0
      );
    },
    fileInputHint() {
      if (this.$produtos_gerenciar.cadastro.customizacao.imagem === "destaque")
        return "A dimensão sugerida para esta imagem é 600x300 pixels e o tamanho máximo é de 2mb.";
      return "A dimensão sugerida para esta imagem é 1080 x 1920 pixels e o tamanho máximo é de 2mb.";
    },
  },
  watch: {
    images(e) {
      const hasImagem1 = e.some(image => image.type === "imagem1");
      const hasDestaque = e.some(image => image.type === "destaque");
      const hasMap = e.some(image => image.type === "map");
      if (hasMap && !hasDestaque && !hasImagem1) {
        this.typeImage = "imagem1";
      } else if (hasDestaque && !hasImagem1) {
        this.typeImage = "imagem1";
      } else if (hasImagem1 && !hasDestaque) {
        this.typeImage = "destaque";
      } else if (hasDestaque && hasImagem1) {
        this.typeImage = "map";
      }

      const imagesValues = this.images.reduce((acc, obj) => {
        const type = obj.type;
        const url = obj.url;
        acc[type] = url;
        return acc;
      }, {});
      this.$produtos_gerenciar.cadastro.customizacao.imagens_array = [e];
      this.$produtos_gerenciar.cadastro.customizacao.imagem =
        JSON.stringify(imagesValues);
      if (this.linkEvent) {
        e.forEach(obj => {
          const variacoesFilter = this.linkImageTypes.find(
            o => Object.keys(obj)[0] === o.value
          );
          if (variacoesFilter) {
            this.linkImageTypes.map((item, index) => {
              if (variacoesFilter.value == item.value) {
                this.linkImageTypes[index].show = false;
              }
            });
          }
        });
      } else {
        e.forEach(obj => {
          const variacaoesFilter = this.commonImageTypes.find(
            o => Object.keys(obj)[0] === o.value
          );
          if (variacaoesFilter) {
            this.commonImageTypes.map((item, index) => {
              if (variacaoesFilter.value == item.value) {
                this.commonImageTypes[index].show = false;
              }
            });
          }
        });
      }
    },
    "$produtos_gerenciar.cadastro.customizacao.imagens_array"(e) {
      if (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "IFRAME"
      ) {
        e.forEach(obj => {
          const variacaoesFilter = this.tipo_imagem_iframe.find(
            o => Object.keys(obj)[0] === o.value
          );
          if (variacaoesFilter) {
            this.tipo_imagem_iframe.map((item, index) => {
              if (variacaoesFilter.value == item.value) {
                this.tipo_imagem_iframe[index].show = false;
              }
            });
          }
        });
      }
      if (this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "LINK") {
        e.forEach(obj => {
          const variacoesFilter = this.tipo_imagem_link.find(
            o => Object.keys(obj)[0] === o.value
          );
          if (variacoesFilter) {
            this.tipo_imagem_link.map((item, index) => {
              if (variacoesFilter.value == item.value) {
                this.tipo_imagem_link[index].show = false;
              }
            });
          }
        });
      } else {
        e.forEach(obj => {
          const variacaoesFilter = this.tipo_imagem.find(
            o => Object.keys(obj)[0] === o.value
          );
          if (variacaoesFilter) {
            this.tipo_imagem.map((item, index) => {
              if (variacaoesFilter.value == item.value) {
                this.tipo_imagem[index].show = false;
              }
            });
          }
        });
      }
    },
    "$produtos_gerenciar.cadastro.customizacao.imagem_upload.object"(e) {
      if (e) {
        this.$produtos_gerenciar.cadastro.customizacao.error.imagem_upload = [];
      }
    },
  },
  mounted() {
    if (this.images.length === 2) {
      this.typeImage = "map";
    }
    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "IFRAME") {
      this.tipo_imagem_iframe.forEach((obj, index) => {
        const variacaoesFilter =
          this.$produtos_gerenciar.cadastro.customizacao.imagens_array.find(
            o => Object.keys(o)[0] === obj.value
          );
        if (variacaoesFilter) {
          this.tipo_imagem_iframe[index].show = false;
        }
      });
    }
    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "LINK") {
      this.tipo_imagem_link.forEach((obj, index) => {
        const variacoesFilter =
          this.$produtos_gerenciar.cadastro.customizacao.imagens_array.find(
            o => Object.keys(o)[0] === obj.value
          );
        if (variacoesFilter) {
          this.tipo_imagem_link[index].show = false;
        }
      });
    } else {
      this.tipo_imagem.forEach((obj, index) => {
        const variacaoesFilter =
          this.$produtos_gerenciar.cadastro.customizacao.imagens_array.find(
            o => Object.keys(o)[0] === obj.value
          );
        if (variacaoesFilter) {
          this.tipo_imagem[index].show = false;
        }
      });
    }
    this.$produtos_gerenciar.cadastro.customizacao.error.imagem_upload = [];
  },
};
</script>

<style scoped>
.produtos-customizacao {
  width: 100%;
  margin: 20px 0px 40px 0px;
}

.produtos-add-edit-header-dados-cadastrais {
  width: 487px;
  font-size: 1em;
  align-self: flex-start;
  margin-top: 20px;
}

.divider-title {
  margin-bottom: 30px;
}

.produtos-add-edit-container1 {
  width: 100%;
  /* max-width: 1200px; */
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.input-file-tema {
  border-radius: 10px;
  width: 100%;
}

.imagens-table {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 20px;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
}

.produtos-gerenciar-button {
  color: var(--dl-color-gray-white) !important;
  width: 94%;
  height: 51px;
  display: flex;
  padding: 0px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 10px;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-button1 {
  color: var(--dl-color-gray-white) !important;
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-button3 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-icon {
  fill: var(--dl-color-gray-white) !important;
  width: 1.5rem;
  height: 1.5rem;
}
.image-uploader {
  position: relative;
  border: 2px dashed #ccc;
  padding: 5px;
  text-align: center;
  cursor: pointer;
}

.upload-icon {
  font-size: 50px;
}

.upload-text {
  margin-top: 10px;
}

.drag-hover {
  border: 2px dashed var(--v-tertiary-base);
  background-color: var(--v-base-base);
  transition: all 0.2s ease-in-out;
}
.remove-img-btn {
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
}
.image-preview {
  position: relative;
  border-radius: 50px;
  box-shadow: 11px 11px 22px #d9d9d9, -11px -11px 22px #ffffff;
  max-width: 200px;
  transition: all 0.2s ease-in-out;
}
.image-preview:hover {
  transform: scale(1.07);
}
.image-quantity {
  position: absolute;
  top: -0.1rem;
  right: -0.1rem;
  display: grid;
  place-items: center;
  background-color: var(--v-tertiary-base);
  color: #ffffff;
  padding: 0.25rem 0.55rem;
  border-radius: 0 12px 0 50px;
}
</style>
